/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'

import MainLayout from 'components/layouts/main'
import {
  archiveFlaggedCollection,
  getLatestFlaggedCollections,
  getLatestProjectNews,
} from 'services'
import Button from 'components/commons/button'
import { notifyError, notifySuccess } from 'components/commons/toast'
import { toast, ToastContainer } from 'react-toastify'
import Chip from 'components/commons/chip'

const FlaggedNftCollectionsPage = () => {
  const [flaggedCollectionsList, setFlaggedCollectionsList] = useState<any>([])
  const [limit, setLimit] = useState<number>(10)
  const [archivedList, setArchiveList] = useState<any>([])

  const [chain, setChain] = useState<string>('all')
  const [reason, setReason] = useState<string>('')

  useEffect(() => {
    getFields()
  }, [])

  useEffect(() => {
    getFields()
  }, [limit, chain, reason])

  const getFields = async () => {
    console.log('getFields')
    getLatestFlaggedCollections(limit, chain, reason).then((list: any) => {
      setFlaggedCollectionsList(list)
    })
    return
  }

  function copyToClipboard(name: string, id: string) {
    navigator.clipboard.writeText(id)
    toast(name + ' ID Copied', {
      position: 'bottom-center',
      hideProgressBar: true,
      theme: 'dark',
      autoClose: 1000,
    })
  }

  const onArchive = async (id: string) => {
    const archive: any = await archiveFlaggedCollection(id)
    if (archive?.success) {
      setArchiveList([...archivedList, id])
      notifySuccess('Successfully Archived Flagged Collection')
    } else {
      notifyError('Error Archiving Flagged Collection')
    }
  }

  return (
    <React.Fragment>
      <MainLayout style={{ backgroundColor: '#FFFFFF' }}>
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-2xl text-center pb-4 pt-8 md:text-left lg:text-left px-6'>
            Flagged NFT Collections Page
          </h1>
          <div className='flex items-center pb-6 rounded-lg bg-white md:bg-transparent lg:bg-transparent pl-6'>
            <div className='flex flex-row mr-16'>
              <p style={{ marginRight: 12 }}>Chain:</p>
              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='chain'
                  value='all'
                  required={true}
                  defaultChecked={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setChain('all')
                  }}
                />
                All NFTs
              </label>
              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='chain'
                  value='ethereum'
                  required={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setChain('ethereum')
                  }}
                />
                Ethereum
              </label>
              <label>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='chain'
                  value='solana'
                  required={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setChain('solana')
                  }}
                />
                Solana
              </label>
            </div>
            {/**
             * const [items, setItems] = useState([
    { label: 'Incorrect Price', value: 'Incorrect Price' },
    { label: 'Incorrect Details', value: 'Incorrect Details' },
    { label: 'Incorrect Name / Logo', value: 'Incorrect Name / Logo' },
  ]);
             */}
            <div className='flex flex-row pl-6'>
              <p style={{ marginRight: 12 }}>Reason:</p>
              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='reason'
                  value=''
                  required={true}
                  defaultChecked={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setReason('')
                  }}
                />
                All
              </label>
              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='reason'
                  value='Missing Something'
                  required={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setReason('Missing Something')
                  }}
                />
                Missing Something
              </label>

              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='reason'
                  value='Incorrect Price'
                  required={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setReason('Incorrect Price')
                  }}
                />
                Incorrect Price
              </label>

              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='reason'
                  value='Incorrect Details'
                  required={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setReason('Incorrect Details')
                  }}
                />
                Incorrect Details
              </label>

              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='reason'
                  value='Incorrect Name / Logo'
                  required={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setReason('Incorrect Name / Logo')
                  }}
                />
                Incorrect Name / Logo
              </label>

              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='reason'
                  value='Other'
                  required={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setReason('Other')
                  }}
                />
                Other
              </label>
            </div>
          </div>

          <table className='w-full flex flex-row flex-nowrap overflow-hidden mb-4'>
            <thead className='hidden border-b md:table-header-group lg:table-header-group'>
              <tr className='flex flex-col flex-nowrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0'>
                <th className='text-left p-4 font-bold'>Created at</th>
                <th className='text-left p-4 font-bold'>Project Flagged</th>
                <th className='text-left p-4 font-bold'>Reason</th>
                <th className='text-left p-4 font-bold'>Message</th>
                <th className='text-left p-4 font-bold'></th>
              </tr>
            </thead>
            <tbody className='w-full'>
              {!flaggedCollectionsList && <p>Loading...</p>}

              {flaggedCollectionsList &&
                flaggedCollectionsList.map((doc: any, index: number) => (
                  <>
                    {!archivedList.includes(doc?.id) && (
                      <tr
                        key={index}
                        className='bg-white flex flex-col flex-nowrap rounded-lg mb-2 sm:table-row sm:mb-4 md:rounded-none lg:rounded-none'
                      >
                        <td className='p-4 sm:flex-1'>
                          <p className='text-left font-bold md:hidden lg:hidden py-2'>Created at</p>
                          <p>
                            {doc?.created_at // new Date(doc?.last_updated_at.toDate()).toDateString()
                              ? new Date(doc?.created_at?.toDate()).toLocaleTimeString('en-US', {
                                  // en-US can be set to 'default' to use user's browser settings
                                  month: 'short',
                                  day: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                })
                              : 'N/A'}
                          </p>
                        </td>
                        <td className='p-4 sm:flex-1'>
                          <p className='text-left font-bold md:hidden lg:hidden py-2'>
                            Name & Date Posted
                          </p>
                          <div className='flex flex-col lg:items-center lg:flex-row lg:space-x-2'>
                            <div className='flex shrink-0'>
                              <img src={doc?.image_url} width={50} />
                            </div>
                            <div className='flex-1 truncate'>
                              <p style={{ maxWidth: 200 }}>{doc?.name}</p>
                              <p
                                className='text-sm mr-2'
                                style={{ color: 'grey', fontSize: 12, textTransform: 'capitalize' }}
                              >
                                {doc?.chain} ({doc?.slug})
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className='p-4 sm:flex-1'>
                          <div
                            className='flex flex-col lg:items-center lg:flex-row lg:space-x-2'
                            style={{ maxWidth: 500 }}
                          >
                            <p>
                              {doc?.reason // new Date(doc?.last_updated_at.toDate()).toDateString()
                                ? doc?.reason
                                : 'N/A'}
                            </p>
                          </div>
                        </td>
                        <td className='p-4 sm:flex-1'>
                          <div
                            className='flex flex-col lg:items-center lg:flex-row lg:space-x-2'
                            style={{ maxWidth: 500 }}
                          >
                            <p>
                              {doc?.message // new Date(doc?.last_updated_at.toDate()).toDateString()
                                ? doc?.message
                                : 'N/A'}
                            </p>
                          </div>
                        </td>
                        <td className='p-4 sm:flex-1'>
                          <Button
                            onClick={() => {
                              onArchive(doc?.id)
                            }}
                            className='bg-red-500 font-semibold text-white capitalize px-6'
                          >
                            Archive
                          </Button>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
            </tbody>
          </table>
          <div className='flex justify-center pb-6 rounded-lg bg-white md:bg-transparent lg:bg-transparent'>
            <button
              className='text-blue-700 underline underline-offset-2'
              onClick={() => {
                setLimit(limit + 10)
                getFields()
              }}
            >
              Load More Flagged Collections
            </button>
          </div>
        </div>
        <ToastContainer limit={1} autoClose={3000} />
      </MainLayout>
    </React.Fragment>
  )
}

export default FlaggedNftCollectionsPage
